import ConfigParameter, { gettext } from "../ConfigParameter";

export default class BorderStyle extends ConfigParameter {

    constructor() {
        super('borderStyle', 'selectionButtons', gettext('Border style'), 'borders', 'solid', null, [
            {value: 'solid', template: '<hr style="border-top: 2px solid; margin-top: 15px; width: 16px">'},
            {value: 'dashed', template: '<hr style="border-top: 2px dashed; margin-top: 15px; width: 16px">'},
            {value: 'dotted', template: '<hr style="border-top: 2px dotted; margin-top: 15px; width: 16px">'}
        ]);
    }

}


// WEBPACK FOOTER //
// ./src/cmsCore/Creator/ConfigParameters/ConfigParameters/BorderStyle.js